declare namespace $ {

	type $mol_view__sub_bog_ui_app_command_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_command_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_bog_ui_app_command_3 = $mol_type_enforce<
		ReturnType< $bog_ui_app_command['open_palette'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_ui_app_command_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_ui_app_command_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_command_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_command_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_command_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_ui_command_group__title_bog_ui_app_command_9 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_command_group['title'] >
	>
	type $bog_ui_command_item__label_bog_ui_app_command_10 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_command_item['label'] >
	>
	type $bog_ui_command_item__shortcut_bog_ui_app_command_11 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_command_item['shortcut'] >
	>
	type $bog_ui_command_item__label_bog_ui_app_command_12 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_command_item['label'] >
	>
	type $bog_ui_command_item__shortcut_bog_ui_app_command_13 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_command_item['shortcut'] >
	>
	type $bog_ui_command_item__label_bog_ui_app_command_14 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_command_item['label'] >
	>
	type $bog_ui_command_item__shortcut_bog_ui_app_command_15 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_command_item['shortcut'] >
	>
	type $bog_ui_command_item__label_bog_ui_app_command_16 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_command_item['label'] >
	>
	type $bog_ui_command_group__title_bog_ui_app_command_17 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_command_group['title'] >
	>
	type $bog_ui_command_item__label_bog_ui_app_command_18 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_command_item['label'] >
	>
	type $bog_ui_command_item__shortcut_bog_ui_app_command_19 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_command_item['shortcut'] >
	>
	type $bog_ui_command_item__label_bog_ui_app_command_20 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_command_item['label'] >
	>
	type $bog_ui_command_item__shortcut_bog_ui_app_command_21 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_command_item['shortcut'] >
	>
	type $bog_ui_command_item__label_bog_ui_app_command_22 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_command_item['label'] >
	>
	type $bog_ui_command_item__shortcut_bog_ui_app_command_23 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_command_item['shortcut'] >
	>
	type $bog_ui_command_group__title_bog_ui_app_command_24 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_command_group['title'] >
	>
	type $bog_ui_command_item__label_bog_ui_app_command_25 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_command_item['label'] >
	>
	type $bog_ui_command_item__shortcut_bog_ui_app_command_26 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_command_item['shortcut'] >
	>
	type $bog_ui_command_item__label_bog_ui_app_command_27 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_command_item['label'] >
	>
	type $bog_ui_command_item__label_bog_ui_app_command_28 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_command_item['label'] >
	>
	type $bog_ui_command__showed_bog_ui_app_command_29 = $mol_type_enforce<
		ReturnType< $bog_ui_app_command['palette_showed'] >
		,
		ReturnType< $bog_ui_command['showed'] >
	>
	type $bog_ui_command__commands_bog_ui_app_command_30 = $mol_type_enforce<
		ReturnType< $bog_ui_app_command['demo_commands'] >
		,
		ReturnType< $bog_ui_command['commands'] >
	>
	export class $bog_ui_app_command extends $mol_page {
		description( ): string
		Description( ): $mol_view
		open_title( ): string
		Open_title( ): $mol_view
		open_palette( next?: any ): any
		open_label( ): string
		Open_button( ): $mol_button_minor
		shortcut_hint( ): string
		Shortcut_hint( ): $mol_view
		Open_row( ): $mol_view
		groups_title( ): string
		Groups_title( ): $mol_view
		groups_desc( ): string
		Groups_desc( ): $mol_view
		palette_showed( next?: boolean ): boolean
		Nav_group( ): $bog_ui_command_group
		Nav_home( ): $bog_ui_command_item
		Nav_dashboard( ): $bog_ui_command_item
		Nav_settings( ): $bog_ui_command_item
		Nav_profile( ): $bog_ui_command_item
		Actions_group( ): $bog_ui_command_group
		Actions_new( ): $bog_ui_command_item
		Actions_save( ): $bog_ui_command_item
		Actions_export( ): $bog_ui_command_item
		Settings_group( ): $bog_ui_command_group
		Settings_theme( ): $bog_ui_command_item
		Settings_lang( ): $bog_ui_command_item
		Settings_notifications( ): $bog_ui_command_item
		demo_commands( ): readonly(any)[]
		Palette( ): $bog_ui_command
		title( ): string
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=command.view.tree.d.ts.map